module.exports = __webpack_public_path__ + "media/styles/images/png/circle-plus-gray-dark-cf964fcdace7978efe5679df1140e828.png";